import appConfigStoreModule from '@core/@app-config/appConfigStoreModule';
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { enhanceStore } from '@secret-society/vuejs-store';
import app from './app';

import userStore from './user/userStore';
import establishmentsStore from './establishments/establishmentsStore';

Vue.use(Vuex);

const storeModules = {
  appConfig: enhanceStore(appConfigStoreModule),
  app: enhanceStore(app),
  userStore: enhanceStore(userStore),
  establishmentsStore: enhanceStore(establishmentsStore),
};

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {},
  mutations: {},
  actions: {
    RESET_ALL_STORE({ commit }) {
      try {
        Object.keys(storeModules).forEach((module) => {
          commit(`${module}/RESET_STATE`);
        });
      } catch (e) {
        console.error('RESET_ALL_STORE', e);
      }
    },
  },
  modules: storeModules,
});
